<div class="rd-widget widget-{{widgetConfig?.widgetId}}">
  <table class="widget-large widgetNoTopBorder cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large-two-columns-one-gap-fifty-percent">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-space">&nbsp;</th>
        <th scope="col" class="widget-grid-space">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>

    <tbody>
      <tr class="lightGreyTableRow">
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'propertyName'" [align]="'left'"></widget-label></td>
        <td colspan="7"><widget-value [align]="'right'">{{ widgetData.propertyName }}</widget-value></td>
        <td colspan="2">&nbsp;</td>
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'valuationPortfolioClientManual'" [align]="'left'"></widget-label></td>
        <td colspan="7"><widget-value [align]="'right'">{{widgetData.valuationPortfolioClientManual }}</widget-value></td>
      </tr>
      <tr>
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'labelPropertyCityCountry'" [align]="'left'"></widget-label></td>
        <td colspan="7"><widget-value [align]="'right'">{{ widgetData.propertyCity }} / {{ widgetData.propertyCountry }}</widget-value></td>
        <td colspan="2">&nbsp;</td>
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'reportValuationClientCompany'" [align]="'left'"></widget-label></td>
        <td colspan="7"><widget-value [align]="'right'">{{widgetData.reportValuationClientCompany }}</widget-value></td>
      </tr>
      <tr class="lightGreyTableRow">
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'propertyStreet'" [align]="'left'"></widget-label></td>
        <td colspan="7"><widget-value [align]="'right'">{{ widgetData.address }}</widget-value></td>
        <td colspan="2">&nbsp;</td>
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'valuationPortfolioValuationPortfolioName'" [align]="'left'"></widget-label></td>
        <td colspan="7"><widget-value [align]="'right'">{{widgetData.valuationPortfolioValuationPortfolioName }}</widget-value></td>
      </tr>
      <tr>
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'reportValuationSector'" [align]="'left'"></widget-label></td>
        <td colspan="7"><widget-value [align]="'right'">{{ widgetData.reportValuationSector }}</widget-value></td>
        <td colspan="2">&nbsp;</td>
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'reportValuationPreparerName'" [align]="'left'"></widget-label></td>
        <td colspan="7" *ngIf="!editMode">
          <widget-value [align]="'right'"><label hashtagsetvalue [widget]="this" [page]="page">{{ widgetData.reportValuationPreparerName }}</label></widget-value>
        </td>
        <td colspan="7" *ngIf="editMode">
          <input type="text"
                 hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
                 [elType]="'text'" [page]="page"
                 [editMode]="editMode"
          (setNewValue)="widgetData.reportValuationPreparerName= $event;"
                 id="reportValuationPreparerName" [(ngModel)]="widgetData.reportValuationPreparerName" class="widget-input-text widget-align-right gridster-item-content" maxlength="255" (ngModelChange)="setDirtyFlag(true)" />
        </td>
      </tr>
      <tr class="lightGreyTableRow">
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'valuationPortfolioValuationDate'" [align]="'left'"></widget-label></td>
        <td colspan="7"><widget-value [align]="'right'">{{ widgetData.valuationPortfolioValuationDate | rdLocalizedDate }}</widget-value></td>
        <td colspan="2">&nbsp;</td>
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'labelCurrencyArea'" [align]="'left'"></widget-label></td>
        <td colspan="7"><widget-value [align]="'right'">{{currency }} / {{unitOfLength}}²</widget-value></td>
      </tr>
      <tr>
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'valuationPortfolioReportDate'" [align]="'left'"></widget-label></td>
        <td colspan="7"><widget-value [align]="'right'">{{ widgetData.valuationPortfolioReportDate | rdLocalizedDate }}</widget-value></td>
        <td colspan="2">&nbsp;</td>
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'reportValuationValuationMethod'" [align]="'left'"></widget-label></td>
        <td colspan="7" *ngIf="!editMode">
          <widget-value [align]="'right'">
            <span *ngFor="let vMethod of widgetData.reportValuationValuationMethod">
              {{vMethod | rdReflist: reflists['ref_l2_projectstd_valuationmethod'] }} |
            </span>
          </widget-value>
        </td>
        <td colspan="7" *ngIf="editMode">
          <kendo-multiselect [data]="reflists['ref_l2_projectstd_valuationmethod']" class="widget-input-text widget-report-summary-multi-select"
                             textField="description"
                             valueField="oid"
                             [valuePrimitive]="true"
                             [(ngModel)]="widgetData.reportValuationValuationMethod"
                             (valueChange)="setDirtyFlag(true)">
          </kendo-multiselect>
        </td>
      </tr>
      <tr class="lightGreyTableRow">
        <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'jllRef'" [align]="'left'"></widget-label></td>
        <td colspan="7"><widget-value [align]="'right'">{{ widgetData.jllRef }}</widget-value></td>
        <td colspan="17" *ngIf="widgetData.clientAssetReferenceNumber == '' || widgetData.clientAssetReferenceNumber == null">&nbsp;</td>
        <td colspan="2" *ngIf="widgetData.clientAssetReferenceNumber != '' && widgetData.clientAssetReferenceNumber != null">&nbsp;</td>
        <td colspan="8" *ngIf="widgetData.clientAssetReferenceNumber != '' && widgetData.clientAssetReferenceNumber != null" class="bold"><widget-label [widget]="this" [fieldName]="'clientAssetReferenceNumber'" [align]="'left'"></widget-label></td>
        <td colspan="7" *ngIf="widgetData.clientAssetReferenceNumber != '' && widgetData.clientAssetReferenceNumber != null"><widget-value [align]="'right'">{{widgetData.clientAssetReferenceNumber }}</widget-value></td>
      </tr>
    </tbody>
  </table>
</div>
